import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

export interface FilterInterventions {
    page?: number;
    sort?: string;
    etats?: string[];
    chantierIds?: number[];
    adresseProjetIds?: number[];
    idIntervention: string;
    dateDebutPrevueApres?: string;
    dateDebutPrevueAvant?: string;
}

class RapportASignerService {

    public async getRapportsASigner(params: FilterInterventions): Promise<any> {
        return http.get(Routes.InterventionRoutes.GetRapportsASigner(), { params});
    }

    public async signerRapports(idsRapports: number[]){
        return http.get(Routes.InterventionRoutes.SignerRapports(), {params: {idsRapports: idsRapports, fromWeb: true} });
    }

    public async getExportXlsRapport(params: FilterInterventions): Promise<any> {
        return http.get(Routes.InterventionRoutes.GetExportXlsRapport(), { params, responseType: 'arraybuffer' });
    }
}

export default new RapportASignerService();
